<template>
  <Layout>
    <template v-slot:main>
      <div class="section">
        <div class="receipt-item-list">
          <div class="receipt-item receipt-item_simple"
               v-for="(item, key) in receiptInfo.getItems()"
               :key="`receipt-item-${key}`">
            <div class="receipt-item__main">
              <div class="receipt-item__title">
                {{ item.getName() }}
              </div>
            </div>
            <div class="receipt-item__side">
              <div class="receipt-item__attributes">
                <div class="receipt-item__count">
                  {{ item.getCount() + "x" }}
                </div>
                <div class="receipt-item__sum">
                  {{ item.getPrice() }}
                </div>
              </div>
              <div class="receipt-item__total">
                {{ "= " + item.getTotalSum() }}
              </div>
            </div>
          </div>
        </div>
        <div class="receipt-item receipt-item_total">
          <div class="receipt-item__main">
            <div class="receipt-item__title">
              Итог
            </div>
          </div>
          <div class="receipt-item__side">
            <div class="receipt-item__total">
              {{ receiptInfo.getTotalSum() }}
            </div>
          </div>
        </div>
        <div class="fiscalization-list" v-if="fiscalizationData">
          <div class="fiscalization-item">
            <div class="fiscalization-item__title">ФН</div>
            <div class="fiscalization-item__value">
              {{ fiscalizationData.getFiscalDriver() }}
            </div>
          </div>
          <div class="fiscalization-item">
            <div class="fiscalization-item__title">ФД</div>
            <div class="fiscalization-item__value">
              {{ fiscalizationData.getFiscalDocNumber() }}
            </div>
          </div>
          <div class="fiscalization-item">
            <div class="fiscalization-item__title">ФП</div>
            <div class="fiscalization-item__value">
              {{ fiscalizationData.getFpd() }}
            </div>
          </div>
          <div class="fiscalization-item">
            <div class="fiscalization-item__title">Дата</div>
            <div class="fiscalization-item__value">
              {{ fiscalizationData.getDate() }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import {VIEWS} from '@/views/names'
import Layout from '@/app/components/Layout'
import {mapState} from 'vuex'

export default {
  name: VIEWS.receipt.name,
  components: {
    Layout
  },
  computed: {
    ...mapState({
      /**
       * @param {SaleInfo}
       */
      receiptInfo: state => state.app.receiptInfo
    }),
    fiscalizationData() {
      return this.receiptInfo.getFiscalizationData()
    }
  }
}
</script>
